/**
 * Variant Picker Tabs - JavaScript
 * Handles UK/US/EU tab switching and variant selection
 */

class VariantPickerTabs extends HTMLElement {
  constructor() {
    super();
    
    this.tabs = this.querySelectorAll('.variant-picker-tabs__tab');
    this.selectedValueDisplay = this.querySelector('[data-selected-size]');
    
    this.init();
  }
  
  init() {
    // Set up tab click handlers
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.switchRegion(tab));
    });
    
    // Set up size selection handlers
    const radioInputs = this.querySelectorAll('input[type="radio"]');
    radioInputs.forEach(radio => {
      radio.addEventListener('change', () => this.updateSelectedValueDisplay());
    });
    
    // Initialize display on load
    this.updateSelectedValueDisplay();
  }
  
  switchRegion(selectedTab) {
    const regionIndex = selectedTab.dataset.regionIndex;
    
    // Update active tab
    this.tabs.forEach(tab => tab.classList.remove('active'));
    selectedTab.classList.add('active');
    
    // Show/hide appropriate size regions in all size boxes
    const allRegionSpans = this.querySelectorAll('.size-region');
    allRegionSpans.forEach(span => {
      if (span.dataset.regionIndex === regionIndex) {
        span.style.display = 'block';
      } else {
        span.style.display = 'none';
      }
    });
    
    // Update the selected value display to show the size in the selected region
    this.updateSelectedValueDisplay();
  }
  
  updateSelectedValueDisplay() {
    if (!this.selectedValueDisplay) return;
    
    // Find the currently checked radio
    const checkedRadio = this.querySelector('input[type="radio"]:checked');
    if (!checkedRadio) return;
    
    // Get the full size value from data attribute (e.g., "UK7.5 / EU41.5 / US8.5")
    const fullSize = checkedRadio.dataset.fullSize;
    if (!fullSize) return;
    
    // Find which tab is currently active
    const activeTab = this.querySelector('.variant-picker-tabs__tab.active');
    if (!activeTab) return;
    
    const activeRegionIndex = activeTab.dataset.regionIndex;
    
    // Parse the size and show only the relevant region
    // Format: "UK7.5 / EU41.5 / US8.5" -> split by ' / '
    // Index 0 = UK, Index 1 = EU, Index 2 = US
    // But our region indices are: 0=UK, 1=US, 2=EU
    const sizeParts = fullSize.split(' / ');
    let displaySize = '';
    
    switch(activeRegionIndex) {
      case '0': // UK
        displaySize = sizeParts[0] ? sizeParts[0].replace('UK', '').trim() : '';
        break;
      case '1': // US
        displaySize = sizeParts[2] ? sizeParts[2].replace('US', '').trim() : '';
        break;
      case '2': // EU
        displaySize = sizeParts[1] ? sizeParts[1].replace('EU', '').trim() : '';
        break;
    }
    
    this.selectedValueDisplay.textContent = displaySize;
  }
}

if (!customElements.get('variant-picker-tabs')) {
  customElements.define('variant-picker-tabs', VariantPickerTabs);
}
